import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import EditableAvatar from '../EditableAvatar';

function EditableAvatarDemo() {
  return (
    <Container className="p-0">
      <Container className="mt-10 p-0">
        <h4>Editable Avatar Default Size</h4>
        <EditableAvatar />
        <h4 className={'mt-10'}>Editable Avatar large Size</h4>
        <EditableAvatar size={'large'} />
        <h4 className={'mt-10'}>Editable Avatar with Image</h4>
        <EditableAvatar defaultAvatar={'http://placeimg.com/640/480/people'} />
        <h4 className={'mt-10'}>Static Avatar</h4>
        <EditableAvatar
          defaultAvatar={'http://placeimg.com/640/480/people'}
          variant={'static'}
        >
          {<Fragment>
            <h4 className={'text-sm-24-lg-32  fw-bold'}>Terry Smith</h4>
            <span className={'fw-light'}>50 years</span>
            <span className={'mt-3 fw-normal text-dark-gray'}>Married</span>
          </Fragment>}
        </EditableAvatar>
      </Container>
    </Container>
  );
}

export default EditableAvatarDemo;
